import { ONBOARD_COMPANY, COMPANY_ONBOARD_SUCCESS, COMPANY_ONBOARD_FAILURE } from "../constants";

export default class CompanyOnboardingAction {
    static OnboardCompany(payload, cb) {
        return {
            type: ONBOARD_COMPANY,
            payload,
            cb
        }
    }

    static CompanyOnboardSuccess(payload) {
        return {
            type: COMPANY_ONBOARD_SUCCESS,
            payload
        }
    }

    static CompanyOnboardFailure() {
        return {
            type: COMPANY_ONBOARD_FAILURE,
        }
    }
}
